import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "users",
  "use": "users-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"users\"><path fill-rule=\"evenodd\" d=\"M18.99 8c0-1.66-1.33-3-2.99-3-1.66 0-3 1.34-3 3s1.34 3 3 3 2.99-1.34 2.99-3Zm-8 0c0-1.66-1.33-3-2.99-3-1.66 0-3 1.34-3 3s1.34 3 3 3 2.99-1.34 2.99-3ZM1 16.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5s-7 1.17-7 3.5Zm14.03-3.45c1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5-.29 0-.62.02-.97.05Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol